import React, { useState } from "react";
import {
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import Button from "../button/ButtonController.jsx";
import { FormattedMessage } from "react-intl";

export default function PaymentElementStripe({
  onSetupIntentConfirmed,
  hasBeenClicked,
  setHasBeenClicked,
  customer,
  addInvoicePaymentMethod,
  clearErrors,
  isFromRegistrationForm = false,
}) {
  const stripe = useStripe();
  const elements = useElements();
  const [message, setMessage] = useState(null);
  const [paymentType, setPaymentType] = useState("");
  const [stripePaymentType, setStripePaymentType] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);
  const [isInvoiceActive, setIsInvoiceActive] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] =
    useState("standard_payment");

  const togglePaymentMethod = (method) => {
    if (clearErrors) clearErrors();

    setSelectedPaymentMethod(method);
    setIsFormValid(false);
    if (method === "invoice") {
      setPaymentType("customer_balance");
      setIsInvoiceActive(true);
      setIsFormValid(true);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements || (!isFormValid && !isInvoiceActive)) {
      return;
    }

    setHasBeenClicked(true);

    if (isInvoiceActive) {
      onSetupIntentConfirmed(paymentType);
    } else {
      let returnUrl = window.location.href;
      const hasQueryParams = returnUrl.includes("?");
      if (isFromRegistrationForm) {
        returnUrl += `${hasQueryParams ? "&" : "?"}from_registration_form=true`;
      }

      const { error, setupIntent } = await stripe.confirmSetup({
        elements,
        redirect: "if_required",
        confirmParams: {
          return_url: returnUrl,
        },
      });

      if (error) {
        setMessage(error.message);
        setHasBeenClicked(false);
      } else {
        onSetupIntentConfirmed(stripePaymentType, setupIntent.id);
      }
    }
  };

  const billingDetails = {
    name:
      customer.firstname && customer.lastname
        ? `${customer.firstname} ${customer.lastname}`
        : "",
    email: customer.billing_email || customer.email || "",
    phone: customer.phone_number || "",
    address: {
      line1: customer.billing_address || "",
      city: customer.billing_city || "",
      country: customer.billing_country || "",
      postal_code: customer.billing_postcode || "",
    },
  };

  return (
    <form id="payment-form">
      {addInvoicePaymentMethod && (
        <div className={"toggle-buttons-container"}>
          <div
            className={`toggle-button ${
              selectedPaymentMethod === "standard_payment" ? "active" : ""
            }`}
            style={{ marginRight: "4px" }}
            onClick={() => togglePaymentMethod("standard_payment")}
          >
            <FormattedMessage
              id="paymentMethods"
              defaultMessage="Bezahlmethoden"
            />
          </div>
          <div
            className={`toggle-button ${
              selectedPaymentMethod === "invoice" ? "active" : ""
            }`}
            style={{ marginLeft: "4px" }}
            onClick={() => togglePaymentMethod("invoice")}
          >
            <FormattedMessage id="invoice" defaultMessage="Auf Rechnung" />
          </div>
        </div>
      )}
      {selectedPaymentMethod === "standard_payment" && stripe && (
        <div
          id={"payment-element"}
          onClick={() => console.log("Clicking on payment-element")}
        >
          <PaymentElement
            options={{
              layout: "tabs",
              defaultValues: {
                billingDetails: billingDetails,
              },
              readOnly: isInvoiceActive,
            }}
            onChange={(event) => {
              if (clearErrors) clearErrors();

              setIsFormValid(event.complete);
              setIsInvoiceActive(false);
              setPaymentType(event.value.type);

              if (event.complete && event.value && event.value.type) {
                setStripePaymentType(event.value.type);
              }
              if (event.error) {
                console.log("Error:", event.error.message);
              }
            }}
          />
        </div>
      )}
      <div style={{ marginTop: "30px" }}>
        <Button
          style={{ backgroundColor: "var(--colorSecondary)" }}
          onClick={handleSubmit}
          disabled={!isFormValid || hasBeenClicked}
          className="button-confirm-payment"
        >
          {hasBeenClicked ? (
            <span style={{ color: "black" }}>
              <FormattedMessage
                id="processing"
                defaultMessage="... in Bearbeitung ..."
              />
            </span>
          ) : (
            <FormattedMessage id="confirm" defaultMessage="Bestätigen" />
          )}
        </Button>
      </div>
      {message && <div id="payment-message">{message}</div>}
    </form>
  );
}
